 
 export function LoggerClass<T extends new (...args: any[]) => any>(constructor: T): T {
  return class extends constructor {
    cn = constructor.name;
    className = constructor.name;

  };
}
